import memoize from 'transmute/memoize';
// @ts-ignore: Untyped file
import { removeOutlookLineBreaks } from './removeOutlookLineBreaks';
// @ts-ignore: Untyped file
import { replaceGmailDivs } from './replaceGmailDivs';
// @ts-ignore: Untyped file
import { removeStyles } from './removeStyles';
// @ts-ignore: Untyped file
import { fixImages } from './fixImages';
// @ts-ignore: Untyped file
import { sanitizeEmail, sanitizeEmailDom } from './sanitizeEmail';
const EMAIL_TRANSFORMERS = [removeOutlookLineBreaks, replaceGmailDivs, removeStyles, fixImages];
export const cleanEmailDom = container => {
  sanitizeEmailDom(container, EMAIL_TRANSFORMERS);
};
/**
 * @description Wraps a container callback to run `cleanEmailDom` before
 * invoking it. Returns a new stable function reference suitable for passing
 * to `evaluateTextAsDom`. Define the wrapped callback at module scope so the
 * reference is stable across calls (required for memoization to work).
 */
export const withCleanEmailDom = callback => container => {
  cleanEmailDom(container);
  return callback(container);
};
export const cleanEmail = memoize(text => {
  return sanitizeEmail(text, EMAIL_TRANSFORMERS);
});